
<div class="card m-1">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="fa fa-desktop"></i><strong>&nbsp;Lines Status</strong>
  </div>
  <div class="card-body">
    <app-ll-total-summary></app-ll-total-summary>
  </div>
</div>

<div class="card m-1">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="fas fa-map-marker-alt"></i><strong>&nbsp;Lines Locations</strong>
  </div>
  <div class="card-body">
    <app-map [outerMap]="true"></app-map>

  </div>
</div>

<div class="card m-1">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="fas fa-chart-pie"></i><strong>&nbsp;Top 5 Speeds</strong>
  </div>
  <div class="card-body">
    <!--*ngIf="accountDetails !=null || accountDetails!=undefined " [accountUcid]="accountDetails.ucid"-->
    <app-cc-account-traffic></app-cc-account-traffic>
  </div>
</div>

